module.exports = __webpack_public_path__ + "media/images/policy-bg-1152-09f1c62ba2345127fd86e7452f287aad.png";